import { render, staticRenderFns } from "./SearchCommon.vue?vue&type=template&id=2474766f&scoped=true&"
import script from "./SearchCommon.vue?vue&type=script&lang=js&"
export * from "./SearchCommon.vue?vue&type=script&lang=js&"
import style0 from "./SearchCommon.vue?vue&type=style&index=0&id=2474766f&lang=less&scoped=true&"
import style1 from "./SearchCommon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2474766f",
  null
  
)

export default component.exports